import { createClient } from '@supabase/supabase-js';

const hostedSupabaseUrl = 'https://wnejprkyowhaqcfamifo.supabase.co';
const hostedSupabaseAnonKey =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InduZWpwcmt5b3doYXFjZmFtaWZvIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzcyMTk4MTIsImV4cCI6MjA5Mjc5NTgxMn0.5EAqoa5o059Js8z7dLNwEOSdlPklwkN9AoZ9rtym0uc';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || hostedSupabaseUrl;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || hostedSupabaseAnonKey;

export const supabase = supabaseUrl && supabaseAnonKey
  ? createClient(supabaseUrl, supabaseAnonKey)
  : null;

export function hasSupabaseConfig(): boolean {
  return Boolean(supabaseUrl && supabaseAnonKey);
}
